export const isNotEmpty = thing => {
  if (typeof thing === "undefined" || thing === null) {
    return false
  }

  if (Array.isArray(thing)) {
    return true
  }

  if (typeof thing === "object") {
    return !!Object.keys(thing).length
  }

  return true
}

export const getCookie = name => {
  const document =
    typeof window === "undefined"
      ? {cookie: {match: () => {}}}
      : window.document
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
    )
  )
  return matches ? decodeURIComponent(matches[1]) : undefined
}

export const deleteCookie = (
  name,
  path = "/",
  domain = window.location.hostname
) => {
  const document =
    typeof window === "undefined" ? {cookie: ""} : window.document
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=${path};domain=${domain};`
}

export const debounce = (func, wait, immediate) => {
  let timeout

  return function () {
    let context = this,
      args = arguments
    let later = () => {
      timeout = null

      if (!immediate) {
        func.apply(context, args)
      }
    }

    let callNow = immediate && !timeout

    clearTimeout(timeout)
    timeout = setTimeout(later, wait)

    if (callNow) {
      func.apply(context, args)
    }
  }
}
